export const mockData = [
  {
    key: "1",
    campaignName: "rfestdh242545vygkhuodte",
    campaignId: "3r346y45ytju325uluil",
    clickThroughs: 1,
    dpv: 4,
    dpvClicks: 4,
    atc: 0,
    atcClicks: 0,
    productSales: "$29.99",
    productSalesClicks: "$29.99",
    brandReferralBonus: "$9.42",
  },
  {
    key: "2",
    campaignName: "rfestdh242545vygkhuodte",
    campaignId: "3r346y45ytju325uluil",
    clickThroughs: 1,
    dpv: 0,
    dpvClicks: 0,
    atc: 0,
    atcClicks: 0,
    productSales: "$29.99",
    productSalesClicks: "$29.99",
    brandReferralBonus: "$9.42",
  },
  {
    key: "3",
    campaignName: "rfestdh242545vygkhuodte",
    campaignId: "3r346y45ytju325uluil",
    clickThroughs: 1,
    dpv: 0,
    dpvClicks: 0,
    atc: 0,
    atcClicks: 0,
    productSales: "$29.99",
    productSalesClicks: "$29.99",
    brandReferralBonus: "$9.42",
  },
];

export enum MetricKeys {
  BRAND_REFERRAL_BONUS = "brand_referral_bonus",
  CLICK_THROUGHS = "click_throughs",
  DPV = "dpv",
  PRODUCT_SALES = "product_sales",
  PURCHASES = "purchases",
  TOTAL_ATC = "total_atc",
  TOTAL_DPV = "total_dpv",
  TOTAL_PRODUCT_SALES = "total_product_sales",
  TOTAL_PURCHASES = "total_purchases",
  TOTAL_UNITS_SOLD = "total_units_sold",
  UNITS_SOLD = "units_sold",
}

export const metricsMock = [
  {
    key: MetricKeys.BRAND_REFERRAL_BONUS,
    label: "Brand Referral Bonus",
    value: 15811,
    color: "#6B4DBA",
    colorName: "color-purple",
  },
  {
    key: MetricKeys.CLICK_THROUGHS,
    label: "Click-throughs",
    value: 226962,
    color: "#5295E0",
    colorName: "color-blue",
  },
  {
    key: MetricKeys.DPV,
    label: "DPV",
    value: 230098,
    color: "#F4D35E",
    colorName: "color-yellow",
  },
  {
    key: MetricKeys.PRODUCT_SALES,
    label: "Product Sales",
    value: 0,
    color: "#00A896",
    colorName: "color-green",
  },
  {
    key: MetricKeys.PURCHASES,
    label: "Total Purchases",
    value: 4827,
    color: "#FF5C5C",
    colorName: "color-red",
  },
  {
    key: MetricKeys.TOTAL_ATC,
    label: "Total ATC",
    value: 0,
    color: "#E07A5F",
    colorName: "color-red",
  },
  {
    key: MetricKeys.TOTAL_DPV,
    label: "Total DPV",
    value: 0,
    color: "#3D5A80",
    colorName: "color-gray",
  },
  {
    key: MetricKeys.TOTAL_PRODUCT_SALES,
    label: "Total Product Sales",
    value: 0,
    color: "#81B29A",
    colorName: "color-green",
  },
  {
    key: MetricKeys.TOTAL_PURCHASES,
    label: "Total Purchases",
    value: 0,
    color: "#F28482",
    colorName: "color-red",
  },
  {
    key: MetricKeys.TOTAL_UNITS_SOLD,
    label: "Total Units Sold",
    value: 0,
    color: "#98C1D9",
    colorName: "color-blue",
  },
  {
    key: MetricKeys.UNITS_SOLD,
    label: "Units Sold",
    value: 0,
    color: "#E0AFA0",
    colorName: "color-yellow",
  },
];

export const mockChartData = [
  {
    date: "Mar 01",
    click_throughs: 10000,
    total_dpv: 5000,
    total_atc: 2000,
    purchases: 1000,
    units_sold: 300,
    brand_referral_bonus: 700,
  },
  {
    date: "Mar 02",
    click_throughs: 30000,
    total_dpv: 15000,
    total_atc: 8000,
    purchases: 3000,
    units_sold: 700,
    brand_referral_bonus: 1700,
  },
  {
    date: "Mar 03",
    click_throughs: 20000,
    total_dpv: 12000,
    total_atc: 5000,
    purchases: 2500,
    units_sold: 600,
    brand_referral_bonus: 1300,
  },
  {
    date: "Mar 04",
    click_throughs: 25000,
    total_dpv: 14000,
    total_atc: 6000,
    purchases: 2700,
    units_sold: 650,
    brand_referral_bonus: 1400,
  },
  {
    date: "Mar 05",
    click_throughs: 35000,
    total_dpv: 20000,
    total_atc: 10000,
    purchases: 4000,
    units_sold: 900,
    brand_referral_bonus: 2000,
  },
  {
    date: "Mar 06",
    click_throughs: 5000,
    total_dpv: 3000,
    total_atc: 1000,
    purchases: 700,
    units_sold: 200,
    brand_referral_bonus: 500,
  },
  {
    date: "Mar 07",
    click_throughs: 4000,
    total_dpv: 2500,
    total_atc: 800,
    purchases: 500,
    units_sold: 150,
    brand_referral_bonus: 300,
  },
];
